import { rgba } from 'polished'

export const black = '#141414'
export const white = '#ffffff'
export const grey = rgba(255,255,255,0.4)
